/* eslint-disable */
import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
// ---- Import hooks
import useMakeRequest from "../../../../hooks/useMakeRequest";
import pixelEvent from "../../../../hooks/pixelEvent";
// ---- Import componets
import Preloader from "../../../../components/UI/Preloader/Preloader";
import Input from "../../../../components/UI/Input/Input";
// ---- Import images
import iconPencil from "../../../../assets/images/profile/icon_pencil.svg";

import "./ProfileDataItem.sass";

function ProfileDataItem({ userData, fieldItem }) {
  const [currentField, setCurrentField] = useState({});
  const [valuesField, setValuesField] = useState("");
  const [errorField, setErrorField] = useState("");
  const [editMode, setEditMode] = useState(false);

  const [setParams, data, isLoading, hasError, error] = useMakeRequest();

  const setCurrentElement = (item) => {
    setEditMode(true);
    if (!errorField) {
      setCurrentField(item);
      setValuesField(item.data);
    }
    pixelEvent({
      evt_src: "acct",
      evt_action: `edit_${item.field}`,
      guid: userData.guid,
    });
  };

  const onSaveChanges = () => {
    if (!errorField) {
      currentField.data = valuesField.trim();
      const p = {};
      p[currentField.field] = valuesField.trim();
      setParams({
        c: "accountStore",
        a: "setAccountAttribute",
        p,
      });
    }
  };

  const onChangeCurrentElement = (e) => {
    setValuesField(e.target.value);

    // eslint-disable-next-line
    const regName =
      /^(?!.*['-]{2})(?!.* -|-.)(?!.*['-]$)(?!.*^['-])[a-z' -]+$/i;
    const regPhone = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    const regEmail =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const regAddress =
      /^(?!.*['`,-]{2})(?!.* -|-.)(?!.*['`,-]$)(?!.*^['`,-])(?=.*[a-z])[a-z0-9,.'`/ -]+(?!.*([,.'`/])\1)(?!.*(?:[^a-z\d]\.|,\.|\/))(?!.*[^a-z\\d]\/|\/[^a-z\\d])[a-z0-9,.'`/ -]+$/i;
    // eslint-disable-next-line default-case
    switch (currentField.title) {
      case "Full name":
        if (!e.target.value.trim()) {
          setErrorField("Field required");
        } else if (!regName.test(e.target.value.trim())) {
          setErrorField("Invalid name");
        } else if (e.target.value.trim().length > 50) {
          setErrorField("Not supported length of the field");
        } else {
          setErrorField("");
        }
        break;
      case "Email":
        if (!regEmail.test(String(e.target.value).toLowerCase())) {
          setErrorField("Invalid email");
        } else if (e.target.value.trim().length > 50) {
          setErrorField("Not supported length of the field");
        } else {
          setErrorField("");
        }
        break;
      case "Primary phone":
        if (!regPhone.test(e.target.value)) {
          setErrorField("Invalid phone");
        } else if (e.target.value.trim().length > 17) {
          setErrorField("Phone number can't be longer than 17 digits");
        } else {
          setErrorField("");
        }
        break;
      case "Address":
        if (!e.target.value) {
          setErrorField("Field required");
        } else if (!regAddress.test(e.target.value.trim())) {
          setErrorField("Invalid address");
        } else if (e.target.value.trim().length > 100) {
          setErrorField("Not supported length of the field");
        } else {
          setErrorField("");
        }
        break;
    }
  };

  useMemo(() => {
    if (data && !hasError && !error) {
      const dataResponse = Object.values(data);
      const dataValues = dataResponse[0];
      currentField.data = dataValues;
      setEditMode(false);
      let pixelParam = {
        evt_src: "reg",
        evt_action: "partial",
        userid: userData.cid,
      };
      if (currentField.field == "fullName") {
        var name = currentField.data.split(" ");
        pixelParam.firstName = name[0] ? name[0] : "";
        name.splice(0, 1);
        pixelParam.lastName = name.join(" ") ? name.join(" ") : "";
      }
      if (currentField.field == "email") {
        pixelParam.email = currentField.data;
      }
      if (currentField.field == "phone") {
        pixelParam.phoneNumber = encodeURIComponent(currentField.data);
      }
      if (currentField.field == "address") {
        pixelParam.address = encodeURIComponent(currentField.data);
      }
      pixelEvent(pixelParam);
    } else {
      setErrorField(error);
    }
  }, [data, error]);

  return (
    <section className="col-12 col-md-6 col-lg-2 profile-data-cell">
      <h5 className="profile-data-cell__title">{fieldItem.title}</h5>
      {editMode && currentField.title === fieldItem.title ? (
        <>
          <Input
            className="profile-data-cell__field"
            value={valuesField}
            onChange={onChangeCurrentElement}
            onBlur={onSaveChanges}
            onKeyPress={(e) => e.key === "Enter" && onSaveChanges()}
            error={errorField}
            autofocus
          />
          {isLoading && (
            <Preloader width="15px" className="profile-data-cell__preloader" />
          )}
        </>
      ) : (
        <span
          role="presentation"
          className={`profile-data-cell__text ${
            fieldItem.isEditable ? `editable` : ""
          } ${
            fieldItem.title === "Address"
              ? "profile-data-cell__text_address"
              : ""
          }`}
          onClick={() => {
            if (fieldItem.isEditable) {
              setCurrentElement(fieldItem);
            }
          }}
        >
          {fieldItem.data}
          <img
            className="profile-data-cell__icon-pencil"
            src={iconPencil}
            alt=""
          />
        </span>
      )}
    </section>
  );
}

ProfileDataItem.propTypes = {
  fieldItem: PropTypes.shape({
    field: PropTypes.string,
    title: PropTypes.string,
    data: PropTypes.string,
    isEditable: PropTypes.bool,
  }),
  userData: PropTypes.objectOf(PropTypes.string),
};
ProfileDataItem.defaultProps = {
  userData: null,
  fieldItem: null,
};

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDataItem);
